"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = normalizeTypeDescriptors;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _assign = _interopRequireDefault(require("lodash/assign"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _ResponseError = _interopRequireDefault(require("../errors/ResponseError"));

var _getJSON = _interopRequireDefault(require("./getJSON"));

/**
 * Transform string types into full-fledged type descriptors.
 * @param {Array} types - The action types from a valid async action
 * @returns {Array}
 */
function normalizeTypeDescriptors(types) {
  var _types = (0, _slicedToArray2.default)(types, 3),
      requestType = _types[0],
      successType = _types[1],
      failureType = _types[2];

  if ((0, _isString.default)(requestType)) {
    requestType = {
      type: requestType
    };
  }

  if ((0, _isString.default)(successType)) {
    successType = {
      type: successType
    };
  }

  if ((0, _isString.default)(failureType)) {
    failureType = {
      type: failureType
    };
  }

  successType = (0, _assign.default)({}, {
    payload: function payload(state, response) {
      return (0, _getJSON.default)(response);
    }
  }, successType);
  failureType = (0, _assign.default)({}, {
    error: true,
    payload: function payload(state, response) {
      return (0, _getJSON.default)(response).then(function (json) {
        return new _ResponseError.default(response.status, response.statusText, json);
      });
    }
  }, failureType);
  return [requestType, successType, failureType];
}